import fetch from "node-fetch";
import { IEvent } from "src/context/models/Event";

export const BASE_URL: string = "sp-api-status/";

export const SECTIONS_URL: string = BASE_URL + "data/sections.json";
export const METADATA_URL: string = BASE_URL + "data/metadata/metadata.json";
export const EVENTS_S3_URL: string = BASE_URL + "data/events.json";
export const EVENTS_API_URL: string = BASE_URL + "api/events";
export const EVENT_API_URL: string = BASE_URL + "api/event";

export function fetchSections() {
    return fetch(SECTIONS_URL);
}

export function fetchMetadata() {
    return fetch(METADATA_URL);
}

export function fetchEventsS3() {
    return fetch(EVENTS_S3_URL);
}

export function fetchEventsAPI() {
    // Go 30 days back
    let since = new Date(new Date().setDate(new Date().getDate() - 30));

    let url = new URL([window.location.origin, EVENTS_API_URL].join('/'));
    url.search = new URLSearchParams({since: since.getTime().toString()}).toString();
    return fetch(url.toString());
}

export function postEvent(event: IEvent) {
    return fetch(EVENT_API_URL, {
        method: "POST",
        body: JSON.stringify(event),
        headers: { "Content-Type": "application/json" }
    });
}

export function deleteEvent(event: IEvent) {
    return fetch(EVENT_API_URL, {
        method: "DELETE",
        body: JSON.stringify(event),
        headers: { "Content-Type": "application/json" }
    });
}